export const ADJUDICATION_SCORES = [
  { id: "REVIEW", label: "Review" },
  { id: "CLEAR", label: "Clear" },
  { id: "CRITERIA_NOT_MET", label: "Does not meet" },
] as const;

export const PARENT_EMPLOYMENT_CHECK_TYPES = ["EMPLOYMENT_VERIFICATIONS_1"];

export const CHILD_EMPLOYMENT_CHECK_TYPES = [
  "EMPLOYMENT_VERIFICATION_MANUAL_1",
  "EMPLOYMENT_VERIFICATION_MANUAL_US_1",
];

export const EMPLOYMENT_VERIFICATION_CHECK_TYPES = [
  ...PARENT_EMPLOYMENT_CHECK_TYPES,
  ...CHILD_EMPLOYMENT_CHECK_TYPES,
];

export const BASIC_CANADIAN_CRIMINAL_RECORD_CHECK_TYPES = [
  "BASIC_CANADIAN_CRIMINAL_RECORD_REPORT_1",
];

export const SUPPORTED_CHECK_TYPES = [
  ...EMPLOYMENT_VERIFICATION_CHECK_TYPES,
  ...BASIC_CANADIAN_CRIMINAL_RECORD_CHECK_TYPES,
];
